import React, { useState } from "react";

const IconCreditCard = ({
  size = 16,
  stroke = 2,
  color = "currentColor",
  hoverColor = "#1890ff",
  marginRight = 8,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={isHovered ? hoverColor : color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        transition: "stroke 0.5s ease",
        marginRight: `${marginRight}px`, // Espacio a la derecha
        marginBottom: "-4px",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <path d="M12 19h-6a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5" />
      <path d="M3 10h18" />
      <path d="M16 19h6" />
      <path d="M19 16l3 3l-3 3" />
      <path d="M7.005 15h.005" />
      <path d="M11 15h2" />
    </svg>
  );
};

export default IconCreditCard;
